// extracted by mini-css-extract-plugin
export default {"failed-message-container":"FailedMessageContainer_failed-message-container__aRurl"};